import { render, staticRenderFns } from "./ModuleArchivedBanner.vue?vue&type=template&id=7097ee70&"
import script from "./ModuleArchivedBanner.vue?vue&type=script&lang=ts&"
export * from "./ModuleArchivedBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports